import { useEffect, useState } from 'react';

import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { formatVolume } from '@/src/utils/format/volume';
import { formatDuration } from '@/src/utils/format/date';
import { applyDiscount } from '@/src/utils/format/amount';
import { generateDataLayerViewItemList } from '@/src/utils/seo/analytics';

export enum EDestinationSwitcher {
  MOST_POPULAR,
  ALL_DESTINATIONS,
  ZONES,
}

export enum EDurationSwitcher {
  DAYS_7 = 604800,
  DAYS_15 = 1296000,
  DAYS_30 = 2592000,
}

interface IProps {
  destinations: Record<string, IZoneWithDestinationsAndPromo>;
  popularDestinations: Record<string, IZoneWithDestinationsAndPromo>;
}

export const useCrossSale = ({ destinations, popularDestinations }: IProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [destinationTypeSwitcher, setDestinationTypeSwitcher] = useState(
    EDestinationSwitcher.MOST_POPULAR
  );
  const [selectedDuration, setSelectedDuration] = useState(
    EDurationSwitcher.DAYS_30
  );

  useEffect(() => {
    setIsExpanded(false);
  }, [destinationTypeSwitcher]);

  const zones: Record<string, IZoneWithDestinationsAndPromo> = {};
  Object.entries(destinations).map(([key, value]) => {
    if (value.countries.length > 1) {
      zones[key] = value;
    }
  });

  useEffect(() => {
    window.dataLayer?.push({
      ecommerce: null,
    });
    if (destinationTypeSwitcher === EDestinationSwitcher.ALL_DESTINATIONS) {
      window.dataLayer?.push(
        generateDataLayerViewItemList(
          destinations,
          destinationTypeSwitcher,
          selectedDuration
        )
      );
    } else if (destinationTypeSwitcher === EDestinationSwitcher.MOST_POPULAR) {
      window.dataLayer?.push(
        generateDataLayerViewItemList(
          popularDestinations,
          destinationTypeSwitcher,
          selectedDuration
        )
      );
    } else {
      window.dataLayer?.push(
        generateDataLayerViewItemList(
          zones,
          destinationTypeSwitcher,
          selectedDuration
        )
      );
    }
  }, [destinationTypeSwitcher, selectedDuration]);

  return {
    isExpanded,
    setIsExpanded,
    destinationTypeSwitcher,
    setDestinationTypeSwitcher,
    selectedDuration,
    setSelectedDuration,
    zones,
  };
};
